module.exports = __webpack_public_path__ + "img/machvat_yes.070fabc6.png";